var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;fill-opacity:0;}\n\t.st1{fill:none;stroke:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-\u6570\u636E\u4E2D\u5FC3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u4F18\\u5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-194, -40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-\\u6570\\u636E\\u4E2D\\u5FC3",
    transform: "translate(193, 39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 1,
    y: 1,
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17",
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    className: "st1",
    d: "M8.5,2.5c1.3,0.1,2.5,0.7,3.4,1.6c1,1,1.6,2.4,1.6,3.9s-0.6,2.9-1.6,3.9S9.5,13.5,8,13.5 s-2.9-0.6-3.9-1.6C3.2,11,2.6,9.8,2.5,8.5h6V2.5z M6.5,1.5v5h-5C1.6,5.2,2.2,4,3.1,3.1S5.2,1.6,6.5,1.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCenter);
export default __webpack_public_path__ + "static/media/data-center.2dca10333f62749d143daaec8cc73105.svg";
export { ForwardRef as ReactComponent };